export const environment = {
  branding: {
    clientName: 'eCheckout | ForFinance',
    faviconUrl: 'img/forfinance/forfinance_favicon.png',
    primaryColor: '#85c227',
    logoUrl: 'img/forfinance/forfinance-logo.png',
    logoAlt: 'ForFinance',
  },
  production: false,
  apiBaseUrl: 'https://cloud4fin.forfinance.com.br:1459/rest',
  endpoints: {
    fullReceiptsDefault: 'wsrest4finadq/full_receipts_default',
    paymentInclusion: 'wsrest4finadq/payment_inclusion',
  },
} as const;
